import { UnifiedCampaignSetup } from "@features/UnifiedCampaignSetup";

export default function CampaignOverviewPage() {
  return <UnifiedCampaignSetup />;
}
